import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Filters from "./filters/Filters";
import Results from "./Results";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { clearDetails } from "../../actions/details";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";

import handleGA, { gaEvents } from "../../googleAnalytics";

const PREFIX = 'Library';

const classes = {
  root: `${PREFIX}-root`,
  mobileFilterButton: `${PREFIX}-mobileFilterButton`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    display: "flex",
    padding: "2em 0",
    width: "100%",
  },

  [`& .${classes.mobileFilterButton}`]: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      zIndex: 11000,
      display: "block",
      position: "fixed",
      top: "6.5rem",
      right: "1rem",
      background: "#fff",
      boxShadow:
        "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
	  padding: "0.75rem",
	  fontSize: "0.1rem",
    },
    "&:hover": {
      background: "#e1e1e1",
      boxShadow:
        "1px 3px 2px -2px rgba(0,0,0,0.2),1px 2px 2px 1px rgba(0,0,0,0.14),1px 2px 4px 1px rgba(0,0,0,0.12)",
    },
  }
}));

const Library = ({ clearDetails }) => {
  window.scrollTo(0, 0);

  const [showFilters, setShowFilters] = useState(true);
  const [showResults, setShowResults] = useState(true);
  const [mobileStateUpdated, setMobileStateUpdated] = useState(false);

  const mobileToggleFilters = () => {
    window.scrollTo(0, 0);
    if (showResults) {
      setShowFilters(true);
      setShowResults(false);
    } else {
      setShowFilters(false);
      setShowResults(true);
    }
  };

  useEffect(() => {
    clearDetails();
  }, [clearDetails]);

  const handleViewportRendering = () => {
    if (window.innerWidth > 960) {
      setShowFilters(true);
      setShowResults(true);
      setMobileStateUpdated(false);
    } else {
      if (!mobileStateUpdated) {
        setMobileStateUpdated(true);
        setShowFilters(false);
        setShowResults(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      handleViewportRendering();
    });
    handleViewportRendering();
  }, []);

  useEffect(() => {
    // Google Analytics
    handleGA(gaEvents.PAGE_VIEW, window.location.pathname);
  }, []);

  useEffect(() => {
    document.title = "Natural Hazard Modeling & Planning | Hazus Loss Library";
    document.getElementById('description').content = "Search, filter, and download historic Hazus analyses and scenario-based natural hazards by location, year, hazard type, and analysis type.";
  })

  return (
    <Root className={classes.root}>
      {showFilters && <Filters />}
      {showResults && <Results />}
      <IconButton
        className={classes.mobileFilterButton}
        label="clear search"
        aria-label="clear search"
        onClick={mobileToggleFilters}
      >
        <FilterListIcon />
      </IconButton>
    </Root>
  );
};

Library.propTypes = {
  clearDetails: PropTypes.func.isRequired,
};

export default connect(null, { clearDetails })(Library);